// extracted by mini-css-extract-plugin
export default {"link":"ServerErrorPage_link__-RiTI","info":"ServerErrorPage_info__ACUhd"};